var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error hello-wrapper"},[_c('div',{staticClass:"panel white-tilted-1"},[_c('div',{staticClass:"instructions"},[_c('p',[_c('strong',{staticClass:"name"},[_vm._v("Olá "+_vm._s(_vm.simulado.PrimeiroNome)+",")])]),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.message)+"\n\t\t\t")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-273db7d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/result/error.vue
// module id = Q57e
// module chunks = 1